import AvailablePlanCoverage from './AvailablePlanCoverage';

export default AvailablePlanCoverage;
